import { render, staticRenderFns } from "./RmsData.vue?vue&type=template&id=ab7e8008&scoped=true&"
import script from "./RmsData.vue?vue&type=script&lang=js&"
export * from "./RmsData.vue?vue&type=script&lang=js&"
import style0 from "./RmsData.vue?vue&type=style&index=0&id=ab7e8008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7e8008",
  null
  
)

component.options.__file = "RmsData.vue"
export default component.exports